import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { ConfigService } from '../app.config';
import { BearerHttpService, RequestOptions } from './bearer-http.service';
import { map, retry, catchError } from 'rxjs/operators';
import { EntityToken } from '../entities/EntityToken';

@Injectable({
	providedIn: 'root'
})
export class CatalogService {
	// already stored values, format Map<string, JSON>
	private storedValues: Map<string, object> = new Map();

	constructor(private http2: BearerHttpService) { }

	// TODO Usado en door-picker.component
	public getBayonetas(idPanel: string, idColor: string): Observable<any> {
		return this.http2.Get<EntityToken>(ConfigService.REST_SERVER + '/api/panel/' + idPanel + '/color/' + idColor + '/bayonetas')
			.pipe(
				map(res => { this.storedValues.set('getBayonetas', res); return res; }),
				retry(1),
				catchError(this.errorHandl)
			);
	}

	// TODO Usado en door-picker.component
	public getBayonetasById(id: string): Observable<any> {
		return this.http2.Get<EntityToken>(ConfigService.REST_SERVER + '/api/bayonetas/' + id)
			.pipe(
				map(res => { this.storedValues.set('getBayonetasById', res); return res; }),
				retry(1),
				catchError(this.errorHandl)
			);
	}

	// TODO Usado en door-picker.component
	public getModelosPuertas(idModelo: string): Observable<any> {
		return this.http2.Get<EntityToken>(ConfigService.REST_SERVER + '/api/modelo/' + idModelo + '/modelosPuerta')
			.pipe(
				map(res => { this.storedValues.set('getModelosPuertas', res); return res; }),
				retry(1),
				catchError(this.errorHandl)
			);
	}

	// TODO Usado en door-picker.component
	public getTiposPuertas(idModelo: string): Observable<any> {
		return this.http2.Get<EntityToken>(ConfigService.REST_SERVER + '/api/modeloPuerta/' + idModelo + '/tiposPuerta')
			.pipe(
				map(res => { this.storedValues.set('getTiposPuertas', res); return res; }),
				retry(1),
				catchError(this.errorHandl)
			);
	}

	// TODO Usado en door-picker.component
	public getBayonetasPuertas(): Observable<any> {
		return this.http2.Get<EntityToken>(ConfigService.REST_SERVER + '/api/bayonetas')
			.pipe(
				map(res => { this.storedValues.set('getBayonetasPuertas', res); return res; }),
				retry(1),
				catchError(this.errorHandl)
			);
	}

	// TODO Usado en door-picker.component
	public getPuertas(idTipoPuerta: string): Observable<any> {
		return this.http2.Get<EntityToken>(ConfigService.REST_SERVER + '/api/tiposPuerta/' + idTipoPuerta + '/puertas')
			.pipe(
				map(res => { this.storedValues.set('getPuertas', res); return res; }),
				retry(1),
				catchError(this.errorHandl)
			);
	}

	// Error estandar.
	private errorHandl(error: { error: { message: string; }; }) {
		let errorMessage = '';
		if (error.error instanceof ErrorEvent) {
			// Adquirir error del lado del cliente.
			errorMessage = error.error.message;
		}
		else {
			// Adquirir error del lado del servidor.
			errorMessage = 'Error code: ${error.status}\nMessage: ${error.message}';
		}
		console.log(errorMessage);
		return throwError(errorMessage);
	}
}
